/**
 * Demo auth: minimal residual surface kept for the generic "demo" account
 * that bootstraps the sandbox. Real partner login goes through the normal
 * /auth/login flow and reads tenant.archetype from /tenant/me.
 *
 * The seeded-partner login flow (partnersSeed.ts) has been removed.
 */
import { validateToken } from './tokenValidator';
import { getV2Token } from './v2AuthUtils';

const DEMO_USERNAME = 'demo';
const DEMO_PASSWORD = 'demo123';

export const DEMO_CREDENTIALS = { username: DEMO_USERNAME, password: DEMO_PASSWORD };

export function isDemoCredentials(username: string, password: string): boolean {
  const u = (username || '').trim().toLowerCase();
  const p = (password || '').trim();
  return (u === DEMO_USERNAME || u === 'demo@comply.now') && p === DEMO_PASSWORD;
}

/** Check if the current token is the generic demo user. */
export function isDemoUser(token: string | null): boolean {
  if (!token) return false;
  const user = validateToken(token);
  return user?.username === DEMO_USERNAME;
}

const b64url = (obj: object): string =>
  btoa(JSON.stringify(obj))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/**
 * Build a minimal JWT for the generic demo user. Payload matches
 * TokenPayload in tokenValidator.
 */
export function createDemoToken(): string {
  const now = Math.floor(Date.now() / 1000);
  const payload = {
    id: 'demo-partner-1',
    username: DEMO_USERNAME,
    name: 'Demo Partner',
    title: 'Partner',
    group: 'Partner',
    groupName: 'Partner',
    email: 'demo@comply.now',
    permissions: '',
    exp: now + 86400 * 365,
    iat: now,
  };
  const header = { alg: 'HS256', typ: 'JWT' };
  return `${b64url(header)}.${b64url(payload)}.demo`;
}

export function isCurrentUserDemo(): boolean {
  return isDemoUser(getV2Token());
}
